<template>
  <div class="min-h-screen bg-background-light flex flex-col">


    <!-- ================= MAIN ================= -->
    <main class="flex-1 flex items-center justify-center p-4 sm:p-6">

      <div class="w-full max-w-[460px]">

        <!-- Card -->
        <div class="bg-white rounded-xl shadow-soft border border-primary/5 overflow-hidden">

          <!-- ================= HERO ================= -->
          <div class="relative h-32 sm:h-40 bg-primary/5 flex items-center justify-center">

            <div class="absolute inset-0 opacity-10 dot-pattern"></div>

            <div class="relative bg-white p-3 sm:p-4 rounded-2xl shadow-sm border border-primary/20">
              <span class="material-symbols-outlined text-primary text-4xl sm:text-5xl">
                lock_reset
              </span>
            </div>
          </div>

          <!-- ================= CONTENT ================= -->
          <div class="p-5 sm:p-8">

            <div class="mb-5 sm:mb-6">
              <h2 class="text-xl sm:text-2xl font-bold text-slate-900 mb-2">
                Reset your password
              </h2>

              <p class="text-slate-500 text-sm leading-relaxed">
                No worries, it happens to the best of us. Enter the email address
                associated with your account and we'll send you a secure link.
              </p>
            </div>

            <!-- Form -->
            <form class="space-y-4 sm:space-y-5" @submit.prevent="sendReset">

              <!-- Email -->
              <div>
                <label class="text-sm font-semibold text-slate-700 block mb-1.5">
                  Email Address
                </label>

                <div class="relative">
                  <span class="material-symbols-outlined input-icon">
                    mail
                  </span>

                  <input
                    v-model="email"
                    type="email"
                    required
                    placeholder="name@company.com"
                    class="input-field"
                  />
                </div>
              </div>

              <!-- Button -->
              <button class="primary-btn" :disabled="loading">
                <span>{{ loading ? "Sending..." : "Send Reset Link" }}</span>
                <span class="material-symbols-outlined text-lg">
                  arrow_forward
                </span>
              </button>

              <!-- Back -->
              <button
                type="button"
                @click="goBack"
                class="secondary-btn"
              >
                <span class="material-symbols-outlined text-lg">
                  keyboard_backspace
                </span>
                Back to Login
              </button>
            </form>
          </div>

          <!-- ================= FOOTER ================= -->
          <div class="bg-slate-50 px-5 sm:px-8 py-3 sm:py-4 border-t border-slate-100">
            <p class="text-center text-xs text-slate-500">
              If you don't receive an email within a few minutes, check your spam folder.
            </p>
          </div>
        </div>

        <!-- Support -->
        <div class="mt-4 sm:mt-6 text-center">
          <p class="text-sm text-slate-500">
            Still having trouble?
            <a href="#" class="text-primary font-semibold hover:underline">
              Contact Support
            </a>
          </p>
        </div>
      </div>
    </main>

    <!-- ================= FOOTER ================= -->
    <footer class="py-4 sm:py-6 border-t border-slate-200 text-center">
      <p class="text-xs sm:text-sm text-slate-400">
        © 2026 Reviewsfix Inc.
      </p>
    </footer>
  </div>
</template>

<script>
import { forgotPassword } from "@/apis/userapis";
import {useToast} from 'vue-toastification';

export default {
  data() {
    return {
      toast:null,
      email: '',
      loading: false
    }
  },
   mounted(){
    this.toast = useToast();
  },
  methods: {

    async sendReset() {

      if (!this.email) {
        this.toast.warning("Email required");
        return;
      }

      this.loading = true;

      try {

        const res = await forgotPassword(this.email);

        if (!res.status) {
          this.toast.error(res.success || "Request failed");
          this.loading = false;
          return;
        }

        // ✅ For now (since backend returns temp password)
        this.toast.success(`New password will be sent on your email`);

        // ✅ Redirect to login / verify page
        this.$router.push('/login');

      } catch (error) {

        console.error(error);
        this.toast.error("Reset failed");

      }

      this.loading = false;
    },

    goBack() {
      this.$router.push('/login');
    }
  }
}
</script>
<style scoped>
.shadow-soft {
  box-shadow:
    0 1px 3px rgba(0,0,0,0.06),
    0 10px 30px rgba(0,0,0,0.04);
}

.dot-pattern {
  background-image: radial-gradient(#197fe6 1px, transparent 1px);
  background-size: 18px 18px;
}

/* Input */
.input-field {
  width: 100%;
  height: 44px;
  padding-left: 40px;
  padding-right: 12px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  outline: none;
  transition: all 0.2s ease;
}

.input-field:focus {
  border-color: #197fe6;
  box-shadow: 0 0 0 3px rgba(25,127,230,0.12);
}

.input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #94a3b8;
}

/* Buttons */
.primary-btn {
  width: 100%;
  height: 46px;
  border-radius: 10px;
  background: #197fe6;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.primary-btn:hover {
  background: #166fd1;
}

.secondary-btn {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  font-weight: 500;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.secondary-btn:hover {
  background: #f1f5f9;
}

/* ================= MOBILE POLISH ================= */

@media (max-width: 640px) {

  .primary-btn {
    height: 44px;
  }

  .input-field {
    height: 42px;
  }

}

</style>